import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-K2WKV5F3VE";
const ADMIN_PREFIX = "/q9m4-konsol";

declare global {
  interface Window {
    dataLayer: any[];
    gtag?: (...args: any[]) => void;
    [key: string]: any;
  }
}

/**
 * Tracks SPA route changes in Google Analytics and disables tracking
 * on admin routes (/q9m4-konsol/*).
 */
export const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    const isAdmin = location.pathname.startsWith(ADMIN_PREFIX);

    window[`ga-disable-${GA_ID}`] = isAdmin;

    if (isAdmin) return;

    if (typeof window.gtag === "function") {
      window.gtag("config", GA_ID, { page_path: path });
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(["config", GA_ID, { page_path: path }]);
    }
  }, [location.pathname, location.search]);

  return null;
};

export default Analytics;
